import { ReactElement, useState, useEffect } from 'react';
import { tile } from '@interfaces/interfaces';
import { Field, useFormikContext, getIn } from 'formik';
import { CheckboxInputAccessible, CheckboxInputGroupAccessible } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import { iInstalmentFormValues } from '@services/InstalmentService';
import classnames from 'classnames';
import styles from './InstalmentStep6.module.scss';

function InstalmentStep6(): ReactElement {
  const TILE_DATA_FINES_ACTIONS: tile[] = [
    {
      body: 'My vehicle is wheel clamped.',
      value: 'My vehicle is wheel clamped.',
    },
    {
      body: 'I have received a letter from the Director Fines Victoria about deductions from my pay or bank account, a proposed land charge, a request to provide a Statement of Financial Circumstances or been served with a Declared Director notice.',
      value: 'I have received a letter from the Director Fines Victoria about deductions from my pay or bank account, a proposed land charge, a request to provide a Statement of Financial Circumstances or been served with a Declared Director notice.',
    },
    {
      body: 'My vehicle or other property has been seized or removed by the Sheriff.',
      value: 'My vehicle or other property has been seized or removed by the Sheriff.',
    },
    {
      body: 'My vehicle number plates have been removed by the Sheriff.',
      value: 'My vehicle number plates have been removed by the Sheriff.',
    },
    {
      body: 'I have been notified that a sanction has been or will be applied to my driver licence and/or vehicle registration.',
      value: 'I have been notified that a sanction has been or will be applied to my driver licence and/or vehicle registration.',
    },
  ];
  const { values, touched }: { values: iInstalmentFormValues; touched: any } = useFormikContext();
  const formikContext = useFormikContext();
  const { MoreInfoAboutMatters, NoInfoApplies } = values;
  const hasTouchedMoreInfoAboutMatters = getIn(touched, 'MoreInfoAboutMatters');
  const hasTouchedNoInfoApplies = getIn(touched, 'NoInfoApplies');
  const [isActionGpDisabled, setActionGpDisabled] = useState(false);
  const [isNoneOptDisabled, setNoneOptDisabled] = useState(false);
  useEffect(() => {
    if (NoInfoApplies) {
      setActionGpDisabled(true);
      if (!MoreInfoAboutMatters.includes('None') && MoreInfoAboutMatters.length === 0) {
        getIn(values, 'MoreInfoAboutMatters').push('None');
      }
    } else if (MoreInfoAboutMatters.length !== 0 && !MoreInfoAboutMatters.includes('None')) {
      setNoneOptDisabled(true);
    } else if (MoreInfoAboutMatters.length !== 0 && MoreInfoAboutMatters.includes('None')) {
      formikContext.setFieldValue(
        'MoreInfoAboutMatters',
        getIn(values, 'MoreInfoAboutMatters').filter((action: string) => action !== 'None'),
      );
    } else {
      setActionGpDisabled(false);
      setNoneOptDisabled(false);
    }
  }, [MoreInfoAboutMatters, NoInfoApplies]);

  return (
    <div className={gridStyles.form}>
      <span className="vfH2">More information about your matters</span>
      <div
        className={classnames({
          [gridStyles.gridColFull]: true,
        })}>
        <div className={styles.col}>
          <div
            className={classnames({
              [styles.bold]: true,
              [styles.checkBoxTitleSpacing]: true,
              [styles.inputError]:
                (hasTouchedMoreInfoAboutMatters || hasTouchedNoInfoApplies) && !NoInfoApplies && MoreInfoAboutMatters.length === 0,
            })}>
            Select the statement(s) that apply to you:
          </div>
          <Field name="MoreInfoAboutMatters" component={CheckboxInputGroupAccessible} tileData={TILE_DATA_FINES_ACTIONS} disabled={isActionGpDisabled} displayError={false} />
          <div className={styles.separator}>OR</div>
          <Field name="NoInfoApplies" component={CheckboxInputAccessible} title="None of these apply" disabled={isNoneOptDisabled} displayError={false} hrRequired />
          {(hasTouchedMoreInfoAboutMatters || hasTouchedNoInfoApplies) && !NoInfoApplies && MoreInfoAboutMatters.length === 0 && (
            <div className={styles.inputError}>Please select an option</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default InstalmentStep6;
